import * as Sentry from '@sentry/react';
import { SENTRY_DSN, SENTRY_RELEASE } from '@/config';

// Inicialização isolada do Sentry. Precisa ser o PRIMEIRO import de
// main.tsx para que erros de carregamento dos próprios módulos da
// aplicação já sejam capturados.
//
// Sem DSN definida (nem em build nem em runtime, ver src/config/index.ts),
// o SDK simplesmente não inicializa — a aplicação sobe normalmente, sem
// overhead e sem quebrar o build/boot.
if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.MODE,
    release: SENTRY_RELEASE || undefined,

    integrations: [
      // Mede carregamento de página e navegação entre rotas, e registra
      // cada chamada de fetch como breadcrumb — é assim que se vê o que
      // o usuário fez ANTES do erro.
      Sentry.browserTracingIntegration(),
    ],

    // Fração das navegações/transações com trace de performance. Erros
    // continuam sendo sempre 100%, independente deste valor.
    tracesSampleRate: 0.1,

    // Não envia IP nem dados de formulário automaticamente. O usuário é
    // anexado explicitamente depois do login (ver useSentryUser.ts).
    sendDefaultPii: false,

    // Ruído de browser/extensões que não é bug da aplicação.
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Non-Error promise rejection captured',
    ],
    denyUrls: [/extensions\//i, /^chrome:\/\//i, /^moz-extension:\/\//i],

    // Deixado de fora de proposito: a API do EduQuanto fica em domínio
    // diferente (VITE_API_URL) e ligar os headers sentry-trace/baggage
    // exigiria mudar o CORS do backend para aceitá-los. Sem isso, o
    // trace do front não se conecta ao do backend, mas nenhuma chamada
    // para a API ganha header novo — o CORS atual não precisa mudar.
    // tracePropagationTargets: [/^https:\/\/api\.eduquanto\..+/],
  });

  // eslint-disable-next-line no-console
  console.log(`[sentry] ativo — environment=${import.meta.env.MODE}`);
} else {
  // eslint-disable-next-line no-console
  console.log('[sentry] DSN nao definida (build ou runtime) — monitoramento desativado');
}
